import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => {
  return {
    Content: {
      padding: '2px 2px 15px',
      backgroundColor: '#f8f9fa',

      borderRadius: '10px',
    },
    dialog: {
      textAlign: 'left',
      direction: 'ltr',
      padding: theme.spacing(2),
      lineHeight: 2,
    },
    CircularProgress: { position: 'absolute', top: '41px', right: '9px' , background:'#fff'},
    blockFieldProgress: { position: 'relative' },
    fileUlpload: {
      display: 'flex',
      alignItems: 'center',
      position: 'relative',
      '& label': {
        height: '75px !important',
        width: '500px',
      },
    },
    loading:{
      position: 'absolute',
      right: '50%',
      top:'50%'

    },
    loading: {
      right: '50%',
      position: 'absolute',
      bottom: '50%',
      transform: 'translate(50%, 50%)'
    },
    img: {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
    },
    imgBlock:{
      width: '100%',
      height: '150px',
      border: '1px solid #ccc',
      margin: '10px 0',
      objectFit: 'cover',
      borderRadius: '8px',
      overflow:'hidden',
      position:'relative'
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
    cancelButton: {
      marginLeft: '5px',
    },
    addButton: {
      [theme.breakpoints.up('md')]: {
        transform: 'translate(5px, 31px)',
      },
    },
    isLoading: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      margin: '16px 0',
    },
    isError: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      fontWeight: 'bold',
      margin: '16px 0',
    },
    titleCategory: {
      fontWeight: 'bold',
      fontSize: '13px',
    },
    subItem: {
      fontSize: '12px',
      display: 'flex',
    },
    iconStyle: {
      width: '0.8em',
      height: '0.8em',
      border: '1px solid #ccc',
      backgroundColor: '#e5e5e5',
      borderRadius: '50%',
    },
    iconTop: {
      color: 'white',
      backgroundColor: '#2B3990',
    },
    fonticon8: {
      width: '0.7em',
      height: '0.7em',
      color: '#43a047',
      margin: '0 4px',
      marginTop: '4px',
    },
    headItem: {
      display: 'flex',
      justifyContent: 'space-between',
      cursor: 'pointer',
      backgroundColor: '#f4f4f4',
      padding: '10px',
      borderRadius: '4px',
      fontSize: '12px',
    },
    label: {
      fontSize: '13px',
      color: '#455a64',
      marginBottom: 6,
      '&.MuiInputLabel': {
        '&-shrink': {
          transform: 'translate(0, -2px) scale(1)',
        },
      },
    },
    collpaseContent: {
      borderTop: 'none',
      margin: '0 2px',
      minHeight: '180px',
    },
    mr8: {
      marginRight: '8px',
    },
    mr4: {
      marginRight: '4px',
      padding: '8px',
      marginTop: '12px',
      minHeight: '100px',
    },
    pd16: {
      padding: '16px !important',
    },

    colllapseTop: {
      margin: '8px 0',
      borderRadius: '4px',
      border: '1px solid #eeeeee',
    },

    btnSabt: {
      width: '97%',
      [theme.breakpoints.down('lg')]: {
        width: '97%',
      },
      [theme.breakpoints.down('sm')]: {
        width: '93%',
      },
    },

    customClassDate: {
      position: 'absolute',
      fontSize: '20px',
      left: '84px',
      bottom: '6px',
    },
    customClassUploadTooltip: {
      position: 'absolute',
      fontSize: '20px',
      bottom: '2px',
    },
  };
});
